import { shuffle } from 'radash';
export const shuffleArrayWithLimitOutput = (data: any[], outputAmount: number): any[] => {
  //TODO Create Dynamic array data type
  return shuffle(data).slice(0, outputAmount);
};